import moment from "moment";
import { cutLongText } from "../../../../services/utils";
import { Button, Space, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import GenericTable from "../../../../components/Commons/Table/generic-table.component";
import ShowDataLength from "../../../../components/Commons/Table/results-length-table.component";
import { isMobile } from "react-device-detect";
import FilterButton from "../../../../components/Commons/Table/FilterButton";

export default function TableRejected(props: any) {
    const {
        bookingsLoadingRejected,
        handleTableChange,
        onOpenDetails,
        currentPage,
        search,
        startDate,
        endDate,
        bookingsRejected,
        perPage,
        total,
        filters
    } = props

    const columns: any = [
        {
            title: 'ID Reserva', dataIndex: 'id', key: 'id', sorter: false,
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Data', dataIndex: 'start_date', key: 'start_date', sorter: true,
            render: (_: any, record: any) => moment(record.start_date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Hora', dataIndex: 'hour', key: 'hour', sorter: true,
            render: (_: any, record: any) => record.hour ? moment(record.hour, 'H:mm:ss').format('HH[:]mm') : '',
            responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        },
        {
            title: 'Cliente', dataIndex: 'client_name', key: 'client_name', sorter: false,
            render: (_: any, record: any) => (cutLongText(record.client_name, 40)),
            responsive: ['lg', 'xl'],
        },
        {
            title: 'Operador ', dataIndex: 'operator', key: 'operator', sorter: false,
            render: (_: any, record: any) => (cutLongText(record?.operator?.data?.name || '', 40)),
            responsive: ['lg', 'xl'],
        },
        {
            title: 'Ações', key: 'action', width: 100,
            render: (_: any, record: any) => (
                <Space size="small" direction={isMobile ? 'vertical' : 'horizontal'}>
                    <Tooltip placement="top" title="Detalhes">
                        <Button type="default" shape="circle" size="middle" icon={<EyeOutlined />}
                            onClick={() => onOpenDetails(record)} />
                    </Tooltip>
                </Space>
            )
        }
    ];

    return (
        <GenericTable
            columns={columns}
            dataSource={bookingsRejected}
            pagination={{
                current: currentPage,
                pageSize: perPage,
                showSizeChanger: true,
                total: total
            }}
            loading={bookingsLoadingRejected}
            totalChildren={
                <div className="zone_result_size_n_export" style={isMobile ? { marginTop: 10 } : {}}>
                    <ShowDataLength
                        text='Resultados'
                        size={total}
                        className="show_result_size" />

                    <FilterButton filters={filters} />
                </div>
            }
            empty={{
                createTheFirst: !bookingsRejected.length && !search && !startDate && !endDate,
                textOne: 'Nenhuma reserva reiejtada.',
                textTwo: '',
                link: '',
                createText: ''
            }}
            handleTableChange={handleTableChange}
        />
    )
}